var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CommonOnePlatFormActions from "@redux/actions/common/commonActions";
export var UPDATE_FIELD = "UPDATE_FIELD";
export var UPDATE_PAYMENT_MODE_TYPE = "UPDATE_PAYMENT_MODE_TYPE";
export var SET_PURCHASE_DATA = "SET-PURCHASE-DATA";
export var SET_TOPUP_DATA = "SET_TOPUP_DATA";
export var SET_REDEEM_DATA = "SET_REDEEM_DATA";
export var SET_PURCHASE_MODE = "SET_PURCHASE_MODE";
export var SET_PURCHASE_FEE = "SET_PURCHASE_FEE";
export var SET_TRANSER_IN_DATA = "SET_TRANSFER_IN_DATA";
export var SET_UPLOAD_DECLARTION = "SET_UPLOAD_DECLARTION";
export var SET_WATCHLIST_DATA = "SET_WATCHLIST_DATA";
export var RESET_VALUE = "RESET_VALUE";
export var SET_PAYMENT_SUCCESS = "SET_PAYMENT_SUCCESS";
var PaymentActions = /** @class */ (function (_super) {
    __extends(PaymentActions, _super);
    function PaymentActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentActions.prototype.updateTopupValues = function (req) {
        this.dispatch({
            type: SET_TOPUP_DATA,
            payload: {
                topup: req,
            },
            reducerName: "payment",
        });
    };
    PaymentActions.prototype.resetValue = function () {
        this.dispatch({
            type: RESET_VALUE,
            reducerName: "payment",
        });
    };
    PaymentActions.prototype.updateRedeemValues = function (req) {
        this.dispatch({
            type: SET_REDEEM_DATA,
            payload: {
                redeem: req,
            },
            reducerName: "payment",
        });
    };
    PaymentActions.prototype.updatePurchaseData = function (req) {
        this.dispatch({
            type: SET_PURCHASE_DATA,
            payload: { purchase: req },
            reducerName: "payment",
        });
    };
    PaymentActions.prototype.updatePaymentModeValues = function (req) {
        this.dispatch({
            type: SET_PURCHASE_MODE,
            payload: { paymentMode: req },
            reducerName: "payment",
        });
    };
    PaymentActions.prototype.updatePurchaseFeeValueProp = function (req) {
        this.dispatch({
            type: SET_PURCHASE_FEE,
            payload: {
                purchaseFee: req,
            },
            reducerName: "payment",
        });
    };
    PaymentActions.prototype.updateUploadDeclarationValueProp = function (req) {
        this.dispatch({
            type: SET_UPLOAD_DECLARTION,
            payload: {
                uploadDeclaration: req,
            },
            reducerName: "payment",
        });
    };
    PaymentActions.prototype.updateARNTransferValues = function (req) {
        this.dispatch({
            type: SET_TRANSER_IN_DATA,
            payload: {
                arnTransfer: req,
            },
            reducerName: "payment",
        });
    };
    PaymentActions.prototype.updatePurchaseSuccess = function (req) {
        this.dispatch({
            type: SET_PAYMENT_SUCCESS,
            payload: {
                paymentSuccess: req,
            },
        });
    };
    PaymentActions.prototype.setError = function (payload, errorType) {
        throw new Error("Method not implemented.");
    };
    PaymentActions.prototype.hideError = function (errorType) {
        throw new Error("Method not implemented.");
    };
    return PaymentActions;
}(CommonOnePlatFormActions));
export default PaymentActions;
